module.exports = {
    USER: {
        ROLE_ADMIN: 1,
        ROLE_USER: 2
    },

    MAX_RESULTS: 100000
};
